module.exports = __webpack_public_path__ + "4e1bd9fd727065a39adb233ee62d30a1.png";